import { Translations } from './translations.interface';

export const defaultTranslations: Translations = {
  columnName: 'Name',
  columnLanguageTag: 'Language tag',
  tooltipActionCopy: 'Copy',
  tooltipActionDelete: 'Delete',
};
